import { useRef } from 'react'
import FormChangePassword from '../FormChangePassword'
import { Background, ModalWrapper, HeaderModalClose } from './styles'
import IconClose from '../../assets/icons/icon-close.svg'

const FormChangePasswordModal = ({ showModal, setShowModal }) => {
  const modalRef = useRef()

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal}>
          <ModalWrapper>
            <FormChangePassword setShowModal={setShowModal} />
            <HeaderModalClose
              className="header-modal-close"
              aria-label="Close modal"
              onClick={() => setShowModal((prev) => !prev)}
            >
              {/* <Icon name="icon-close" /> */}
              <img src={IconClose} alt="" />
            </HeaderModalClose>
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  )
}

export default FormChangePasswordModal
